export const REDUCER_NAME = 'task-detail'




// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/const.js